import { keys } from '@wix/wix-data-client-common-standalone'

import {
  type DataBindingConnectionConfigByRole,
  type DataBindingControllerConnection,
  type DataBindingControllerConnectionWithRole,
  type DataBindingRole,
} from '../types'
import { isControllerConnectionWithRole } from './isControllerConnectionWithRole'

const setControllerConnectionConfig = <Role extends DataBindingRole>({
  connections,
  role,
  config,
}: {
  connections: DataBindingControllerConnection[]
  role: Role
  config: DataBindingConnectionConfigByRole[Role]
}): DataBindingControllerConnection[] => {
  for (let index = 0; index < connections.length; index += 1) {
    const connection = connections[index]
    if (isControllerConnectionWithRole(connection, role)) {
      const reconfiguredConnection: DataBindingControllerConnectionWithRole<Role> =
        { ...connection, config }
      return [
        ...connections.slice(0, index),
        reconfiguredConnection,
        ...connections.slice(index + 1),
      ]
    }
  }
  throw new Error(`No controller connection with role "${role}".`)
}

export const setControllerConnectionConfigs = ({
  connections,
  configByRole,
}: {
  connections: DataBindingControllerConnection[]
  configByRole: {
    [Role in DataBindingRole]?: DataBindingConnectionConfigByRole[Role]
  }
}): DataBindingControllerConnection[] =>
  keys(configByRole).reduce(
    (connections, role) =>
      (<Role extends DataBindingRole>(role: Role) => {
        const config = configByRole[role]
        return config !== undefined
          ? setControllerConnectionConfig({ connections, role, config })
          : connections
      })(role),
    connections,
  )
